import { LogLevel } from "@azure/msal-browser";
import { logger } from "../services/logger";

const tenantId = import.meta.env.VITE_MSAL_TENANT_ID;
const clientId = import.meta.env.VITE_MSAL_CLIENT_ID;
const signinUrl = import.meta.env.VITE_MSAL_SIGNIN_URL;
const b2cTenant = import.meta.env.VITE_B2C_TENANT;
const b2cClientId = import.meta.env.VITE_B2C_CLIENT_ID;
const b2cAuthority = import.meta.env.VITE_B2C_AUTHORITY;
const redirectUri = `${window.location.origin}`;
const b2cSignInPolicy = import.meta.env.VITE_B2C_SIGNIN_POLICY;
const isDev = process.env.NODE_ENV === "development";

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: `${signinUrl}${tenantId}`,
    redirectUri: redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ): void => {
        if (containsPii) return;

        if (!isDev && (level === LogLevel.Info || level === LogLevel.Verbose)) {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            logger.error("Auth", message);
            break;
          case LogLevel.Info:
            logger.info("Auth", message);
            break;
          case LogLevel.Verbose:
            logger.debug("Auth", message);
            break;
          case LogLevel.Warning:
            logger.warn("Auth", message);
            break;
        }
      },
    },
  },
};
export const loginRequest = {
  scopes: [`api://${clientId}/user_impersonation`],
};

export const b2cConfig = {
  ...msalConfig,
  auth: {
    clientId: b2cClientId,
    authority: `${b2cAuthority}/${b2cSignInPolicy}`,
    redirectUri: redirectUri,
    knownAuthorities: [b2cTenant],
  },
};

export const b2cLoginRequest = {
  scopes: ["openid", "profile"],
};
